/**
 * Deck Service
 * API calls for deck management
 */

import api from '../utils/api.js';

export const deckService = {
  /**
   * Get all supported langCodes
   */
  getLanguages: async () => {
    return api.get('/decks/langCodes');
  },

  /**
   * Create a new deck
   */
  createDeck: async (name, topic, durationFrom, durationTo, identityKey, identityId, assets, priority, position, coverType, langCode) => {
    return api.post('/decks', { name, topic, durationFrom, durationTo, identityKey, identityId, assets, priority, position, coverType, langCode });
  },

  /**
   * Get all decks
   */
  getAllDecks: async (params = {}) => {
    return api.get('/decks', { params });
  },

  /**
   * Search decks by name
   */
  searchDecks: async (query, params = {}) => {
    return api.get('/decks/search', { params: { query, ...params } });
  },

  /**
   * Get deck by ID
   */
  getDeckById: async (id) => {
    return api.get(`/decks/${id}`);
  },

  /**
   * Update deck details (name, topic, identityKey, identityId, durationFrom, durationTo, assets, priority, position, coverType, langCode)
   */
  updateDeck: async (id, name, topic, durationFrom, durationTo, identityKey, identityId, assets, priority, position, coverType, langCode) => {
    return api.put(`/decks/${id}`, { name, topic, durationFrom, durationTo, identityKey, identityId, assets, priority, position, coverType, langCode });
  },

  /**
   * Archive deck
   */
  archiveDeck: async (id) => {
    return api.delete(`/decks/${id}`);
  },

  /**
   * Add news to deck
   */
  addNewsToDeck: async (deckId, newsId) => {
    return api.post(`/decks/${deckId}/news`, { newsId });
  },

  /**
   * Remove news from deck
   */
  removeNewsFromDeck: async (deckId, newsId) => {
    return api.delete(`/decks/${deckId}/news/${newsId}`);
  },

  /**
   * Get all news in a deck
   */
  getDeckNews: async (deckId, params = {}) => {
    return api.get(`/decks/${deckId}/news`, { params });
  },

  /**
   * Get deck with full details including all news items
   * Returns deck name, created by (email), updated by (email), history, and all news items
   */
  getDeckFullDetails: async (id, params = {}) => {
    return api.get(`/decks/${id}/details`, { params });
  },

  /**
   * Reorder news in deck
   */
  reorderNews: async (deckId, newsOrder) => {
    return api.put(`/decks/${deckId}/news/reorder`, { newsOrder });
  },

  /**
   * Create deck - change status from 'draft' to 'created'
   */
  createDeckStatus: async (deckId) => {
    return api.post(`/decks/${deckId}/create`);
  },

  /**
   * Publish deck - change status from 'created' to 'published'
   */
  publishDeckStatus: async (deckId, position, durationFrom, durationTo) => {
    return api.post(`/decks/${deckId}/publish`, { position, durationFrom, durationTo });
  },

  /**
   * Get signed URL for asset upload
   */
  getUploadSignedUrl: async (fileName, contentType, fileType) => {
    return api.get('/decks/upload-signed-url', {
      params: { fileName, contentType, fileType },
    });
  },
};
